import React from 'react';
import './SteelRollerChainSprocket.css';

const SteelRollerChainSprocket = () => {
  return (
    <div className="roller-chain-page">
      <div className="roller-chain-item">
        <h2 className="item-title">TD-199-015</h2>
        <div className="item-subtitle">Steel Roller Chain Sprocket</div>
        <div className="item-subsubtitle">25R x 6ft</div>
        <img src="/Images/Steel-Roller-Chain-Sprocket.png" alt="TD-199-015" className="roller-chain-image" />
      </div>
    </div>
  );
};

export default SteelRollerChainSprocket;
